import { render, staticRenderFns } from "./ListLanguage.vue?vue&type=template&id=00a259b2&scoped=true"
import script from "./ListLanguage.vue?vue&type=script&lang=js"
export * from "./ListLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a259b2",
  null
  
)

export default component.exports